import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import {
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../global.variable';
import { AppService } from '../../app.service';
import { ClientsService } from '../../pages/pages/clients/clients.service';
import { IncidentsService } from '../../pages/pages/incidents/incidents.service';
import { LoadingSpinnerService } from '../../shared/services/loading-spinner.service';
import { ToasterService } from '../../shared/services/toaster.service';

@Component({
  selector: 'gtapp-incidents',
  standalone: false,
  templateUrl: './incidents.component.html',
  styleUrl: './incidents.component.scss',
})
export class IncidentsComponent implements OnInit, OnDestroy {
  @Input() clientData: any = {};
  @Input() siteData: any = {};

  incidentSearchString: string = '';

  previousIncidents: number = 0;
  rowsIncidents: number =
    this.appService.getUserData()?.preferences?.incident_page_size || 10;
  pageNumIncidents: number = 1;
  totalPagesIncidents: number = 0;
  sortKeyIncidents: any = '';
  searchParamsIncidents: any;
  totalIncidentCount: number = 0;

  incidentPaginationData: any = {};

  incidentDetailsTableView: any = [];

  incidentDropDownList: any = [];

  otherParamsIncidents: any = {
    apiFiltering: true,
  };

  largeView: Boolean = isLargeScreen;

  tableStyle = {
    'overflow': 'auto',
    'max-height': this.largeView ? '75vh' : '65vh',
  };

  constructor(
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private clientService: ClientsService,
    private incidentService: IncidentsService,
  ) {}

  ngOnDestroy(): void {}
  async ngOnInit() {
    if (this.route.snapshot.queryParamMap.get('clientData')) {
      this.clientData =
        this.route.snapshot.queryParamMap.get('clientData') || {};
    }
    if (this.route.snapshot.queryParamMap.get('siteData')) {
      this.siteData = this.route.snapshot.queryParamMap.get('siteData') || {};
    }

    if (!this.clientData?.id) {
      const primeContractors: any = await this.getPrimeContractor();

      const primeContractor = primeContractors?.[0];
      if (!primeContractor) {
        this.toasterService.setMessage({
          errorMessage: '',
          successMessage: 'Prime Contractor Details Not Found',
        });
        return;
      }
      this.clientData = primeContractor;
    }
    this.formatRouteUrl();
    this.getTableDetails();
    this.getIncidentListData();
  }

  async getPrimeContractor() {
    const response: any = await firstValueFrom(
      this.clientService.fetchCustomerList({ prime_contractors: 1, rows: 1 }),
    );

    return response?.data || [];
  }

  getIncidentsCount(reqBody: any, reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.incidentService
      .getIncidents(reqBody, params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.otherParamsIncidents = {
            ...this.otherParamsIncidents,
            paginationData: {
              totalRows: response?.total_count,
              previousRows: this.previousIncidents,
              rows: this.rowsIncidents,
              pageNum: this.pageNumIncidents,
              totalPages: this.totalPagesIncidents,
            },
          };

          this.totalIncidentCount = Math.max(
            response?.total_count,
            this.totalIncidentCount,
            0,
          );
        }
      });
  }

  getIncidentListData(getCount = true) {
    let params: any = { selected_filter: 'closed' };
    let reqBody: any = {};
    if (this.rowsIncidents) {
      params['rows'] = this.rowsIncidents;
      let userData =
        this.appService.getUserData()?.preferences?.incident_page_size;
      if (userData?.preferences) {
        userData.preferences.incident_page_size = this.rowsIncidents;
        this.appService.setUserData(userData);
      }
    }
    if (this.clientData?.id) params.company_id = this.clientData?.id;

    if (this.previousIncidents) {
      params['previous'] = this.previousIncidents;
    }
    if (this.incidentSearchString) {
      params['search_str'] = this.incidentSearchString;
    }

    if (this.searchParamsIncidents) {
      reqBody.ui_filters = this.searchParamsIncidents;
    }

    if (this.sortKeyIncidents) {
      params['sort_key'] = this.sortKeyIncidents;
    }

    if (this.incidentPaginationData?.[this.pageNumIncidents]?.length) return;
    if (getCount) this.getIncidentsCount(reqBody, params);

    this.spinnerService.show();
    this.incidentService
      .getIncidents(reqBody, params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.incidentPaginationData[this.pageNumIncidents] = [
            ...response?.data,
          ];
          this.updateRoutPath();

          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  onChangePaginationIncident(data: any) {
    this.previousIncidents = data?.paginationData?.previousRows;
    this.pageNumIncidents = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsIncidents) {
      this.incidentPaginationData = {};
    }
    this.rowsIncidents = data?.paginationData?.rows;

    this.otherParamsIncidents.paginationData = {
      ...data?.paginationData,
    };
    this.getIncidentListData(false);
  }
  sortColumnIncident(body: any) {
    this.sortKeyIncidents = body?.sortList || [];
    this.searchParamsIncidents = body?.searchParams || {};
    if (body?.site_id) {
      this.searchParamsIncidents = {
        ...this.searchParamsIncidents,
        site_id: body?.site_id,
      };
    }
    this.incidentSearchString = '';
    this.incidentPaginationData = {};
    this.getIncidentListData(false);
  }
  searchColumnIncident(event: any) {
    this.searchParamsIncidents = event?.searchParams || {};
    if (event?.site_id) {
      this.searchParamsIncidents = {
        ...this.searchParamsIncidents,
        site_id: event?.site_id,
      };
    }
    this.clearValues();
    this.getIncidentListData();
  }
  clearValues() {
    this.previousIncidents = 0;
    this.pageNumIncidents = 1;
    this.incidentSearchString = '';
    this.incidentPaginationData = {};
  }

  onIncidentLookup(event: any) {
    if (event.target.value.length > 3) {
      let params: any = { search_str: event.target.value };

      this.incidentService.getIncidents({}, params).subscribe((res: any) => {
        this.incidentDropDownList = res?.data || [];
      });
    }
  }
  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsIncidents,
          otherParams: this.otherParamsIncidents,
          incidentSearchString: this.incidentSearchString,
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }
  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsIncidents = {
          ...this.searchParamsIncidents,
          ...(urlFragmentDetails?.searchParams || {}),
        };

        this.incidentSearchString =
          urlFragmentDetails?.incidentSearchString || '';
        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousIncidents =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousIncidents;
          this.pageNumIncidents =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumIncidents;
          this.rowsIncidents =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsIncidents;
        }
      }
    } catch (error) {}
  }
  getNestedAssignees(rowData: any, maxNumber: any = 2) {
    if (rowData?.assignee?.length > maxNumber) {
      return `${rowData?.assignee?.slice(0, maxNumber)} ...`;
    } else {
      return rowData?.assignee;
    }
  }
  getTableDetails() {
    let tableDetails = this.largeView
      ? [
          {
            header: 'Reported',
            name: 'incident_time',
            datetimeObj: true,
            sortKey: 'incident_time',
          },

          {
            header: 'Incident Type(s)',
            name: 'incident_type',
          },

          {
            header: 'Site',
            name: 'site_name',
            sortKey: 'site__company_name',
            searchKey: 'site__company_name',
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            autoComplete: 'site',
            autoCompleteFilter: { company_id: this.clientData?.id },
          },

          {
            header: 'Address',
            name: 'full_address',
            sortKey: 'full_address',
            searchKey: 'full_address',
          },

          {
            header: 'Reference No.',
            name: 'incident_key',
            searchKey: 'incident_key',
          },
        ]
      : [
          {
            name: 'site_name',
            sortKey: 'site__company_name',
            searchKey: 'site__company_name',
            autoComplete: 'site',
            autoCompleteFilter: { company_id: this.clientData?.id },
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            prefixNestedValue: (row: any) => {
              const appendList: any = [row?.incident_type];
              if (row?.incident_key) appendList.push(row?.incident_key);
              appendList.push('');

              return appendList?.join('\n');
            },
            columnDataStyle: { 'font-weight': 'bold' },
            suffixNestedValue: (row: any) => {
              const appendList: any = ['', row?.full_address];

              // if (row?.created_user) appendList.push(row?.created_user);

              return appendList?.join('\n');
            },
          },
        ];

    updateCustomTableHeaders(tableDetails, this.searchParamsIncidents);

    this.incidentDetailsTableView = [...tableDetails];
  }

  // }
  openIncidentView(incident: any) {
    this.router.navigate(['/pc/preview-incident'], {
      queryParams: { incidentId: String(incident?.id) },
    });
  }
}
